<!-- 宣告表 form 组件 -->
<template>
  <h-form-page :title="h_i18n('d384c8029b5bcbca018e742a22c0bc33')+data.title" @inspection-update="inspectionUpdate" class="ComponentDeclarationForm_style">
    <form-header :title="h_i18n('d384c8029b5bcbca018e742a22c0bc33')" :title2="language == 'en-US' ? '' : 'Product/Component Declaration Form'" title-height="80px" title-width="5" class="top_wrap_style">
      <template #title>
        <h-p align="left" :title="h_i18n('c515f3385e7740c52e22eefc10b62f2b')" class="source_style" style="line-height:32px;">003-S030118-F01</h-p>
        <h-p align="left" :title="h_i18n('e243c63d5df68cbe2d77f4ea5d6cd723')" class="source_style" style="line-height:32px;">{{ h_i18n('9cd62f1b73111b1d5ca44c8b2438b47b') }}</h-p>
      </template>
      <template #body>
        <!-- <h-tr>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>基本信息</span><div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Basal Information</div></h-tr> -->
        
      </template>
    </form-header>
    <form-area :title="data.formTitle" title-height="80px">
      <template #default="{value}">
        <form-body v-if="value===h_i18n('adae83b8d8e2ea891da840f74a05b88f') && (kindType == 'sqmAdd' || kindType == 'sqmModify')" v-loading='data.basalLoading'>
          <tr>
            <report-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" :title2="language == 'en-US' ? '' : 'No.'" colspan="3:5" required>
              <h-autocomplete popper-class="planHidden" v-model="postData.mtlNo" :fetch-suggestions="mtlNoChange" class="mtlNo_input_style"
              :trigger-on-focus="false" @input="() =>
                  postData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''"
                  @clear="plan.showMtlPlan = false ,clearPageData()" clearable filterable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')"
                  @focus="detailFocus('showMtlPlan')">
            </h-autocomplete>
            <h-detail width="500px">
              <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
                max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
                <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="120"></el-table-column>
                <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
              </el-table>
              <div v-if="plan.showMtlPlan && plan.MtlOver600" style="color: red;height: 20px;background-color: #fff;
                  padding-top: 3px;">
                <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('fb36f45f54ec9c9de745b566c6e60e25') }}</span>
              </div>
            </h-detail>
            </report-td>
            <report-td :title="h_i18n('747f9e41209109f904dfa3779284b959')" :title2="language == 'en-US' ? '' : 'Name'" colspan="3:5" required>{{ postData.mtlName }}</report-td>
            <report-td :title="h_i18n('bab268d5468de413a7158920799e354d')" :title2="language == 'en-US' ? '' : 'Supplied By'" colspan="3:5" required>{{ postData.supplyName }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" :title2="language == 'en-US' ? '' : 'V code'" colspan="3:5" required>{{ postData.supplyCode }}</report-td>
            <report-td :title="h_i18n('605404ab9ebb3385c54baf979384eaae')" :title2="language == 'en-US' ? '' : 'QC080000 system'" colspan="3:5" required>
              <el-select v-model="postData.rohsSystem">
                <el-option value="1" :label="h_i18n('23c1f39900b3af4c3263449782e288e1')"></el-option>
                <el-option value="2" :label="h_i18n('4fcdbfe56e37c51ba9012fc8d7271cf9')"></el-option>
              </el-select>
            </report-td>
            <report-td :title="h_i18n('9a311a560c9c62304ebdf6eb84b54ec3')" :title2="language == 'en-US' ? '' : '(RoHS guarantee No.)'" colspan="3:5">{{ postData.guaranteeNo }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('809844de5f86e5f9da3e31e24d4e5808')" :title2="language == 'en-US' ? '' : 'Declartion Date'" colspan="3:5">{{ time(postData.declarationDate) }}</report-td>
            <report-td :title="h_i18n('c2cf8689fd0e8203797dbbd7f8475ff0')" :title2="language == 'en-US' ? '' : 'Declaration No.'" colspan="3:5">{{ postData.rohsNo }}</report-td>
            <report-td :title="h_i18n('dad736217dba5b136a0dedd3e7fc18ec')" :title2="language == 'en-US' ? '' : 'Contact Person'" colspan="3:5">
              <el-input v-model="postData.contactPerson"></el-input>
            </report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('09a1f6985a9fb0915ecea9874daa4780')" :title2="language == 'en-US' ? '' : 'Telephone Number'" colspan="3:5" required>
              <el-input v-model="postData.telephoneNumber" type="tel" @input="telephoneNumberInput"></el-input>
            </report-td>
            <report-td :title="h_i18n('7650487a8758fd50c87d6c9cff0aa5ac')" :title2="language == 'en-US' ? '' : 'Address'" colspan="3:5" required>
              <el-input v-model="postData.address"></el-input>
            </report-td>
            <report-td :title="h_i18n('5d73c09499a08557279f7554a0837404')" :title2="language == 'en-US' ? '' : 'Apply for factory audit'" colspan="3:5" required>
              <el-select v-model="postData.auditFactoryId" @change="auditFactoryChange">
                <el-option v-for="item in data.auditFactoryList" :key="item.valueId" :value="item.valueId" :label="item.valueName"></el-option>
              </el-select>
            </report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('1b9b4711fd9584e570c22e0d2ae70b0b')" :title2="language == 'en-US' ? '' : 'Special code for the same material composition'" colspan="6:6">
              {{ postData.relatedMtlNo }}
            </report-td>
            <report-td :title="h_i18n('a1323cc265292654b418fd3ea7509701')" :title2="language == 'en-US' ? '' : 'Supply For'" colspan="6:6">
              {{ postData.supplyFor }}
              <!-- <span style="display: none;">{{ postData.supplyForId }}</span> -->
            </report-td>
          </tr>
        </form-body>

        <form-body v-if="value===h_i18n('adae83b8d8e2ea891da840f74a05b88f') && (kindType == 'sqmDetail' || kindType == 'hmqmDetail'|| kindType == 'sqmAudit' || kindType == 'hmqmAudit')">
          <tr>
            <report-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" :title2="language == 'en-US' ? '' : 'No.'" colspan="3:5">
              <span style="color:#2164F5;text-decoration:none ;cursor:pointer;"
               @click="props.kindType.includes('sqm') ? 
               toRohsConformityDeclarationsDetail(getData.basalInfo.mtlNo,getData.basalInfo.supplyCode,getData.basalInfo.supplyName,getData.basalInfo.conformityDeclarationsId)
                : toHmqmRoHSDetaile(getData.basalInfo.conformityDeclarationsId)">
               {{ getData.basalInfo.mtlNo }}</span>
            </report-td>
            <report-td :title="h_i18n('747f9e41209109f904dfa3779284b959')" :title2="language == 'en-US' ? '' : 'Name'" colspan="3:5">{{ getData.basalInfo.mtlName }}</report-td>
            <report-td :title="h_i18n('bab268d5468de413a7158920799e354d')" :title2="language == 'en-US' ? '' : 'Supplied By'" colspan="3:5">{{ getData.basalInfo.supplyName }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" :title2="language == 'en-US' ? '' : 'V code'" colspan="3:5">{{ getData.basalInfo.supplyCode }}</report-td>
            <report-td :title="h_i18n('605404ab9ebb3385c54baf979384eaae')" :title2="language == 'en-US' ? '' : 'QC080000 system'" colspan="3:5">
              <span v-if="getData.basalInfo.rohsSystem == '1'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
              <span v-else-if="getData.basalInfo.rohsSystem == '2'">{{ h_i18n('4fcdbfe56e37c51ba9012fc8d7271cf9') }}</span>
            </report-td>
            <report-td :title="h_i18n('9a311a560c9c62304ebdf6eb84b54ec3')" :title2="language == 'en-US' ? '' : '(RoHS guarantee No.)'" colspan="3:5">{{ getData.basalInfo.guaranteeNo }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('809844de5f86e5f9da3e31e24d4e5808')" :title2="language == 'en-US' ? '' : 'Declartion Date'" colspan="3:5">{{ time(getData.basalInfo.declarationDate) }}</report-td>
            <report-td :title="h_i18n('c2cf8689fd0e8203797dbbd7f8475ff0')" :title2="language == 'en-US' ? '' : 'Declaration No.'" colspan="3:5">{{ getData.basalInfo.rohsNo }}</report-td>
            <report-td :title="h_i18n('dad736217dba5b136a0dedd3e7fc18ec')" :title2="language == 'en-US' ? '' : 'Contact Person'" colspan="3:5">{{ getData.basalInfo.contactPerson }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('09a1f6985a9fb0915ecea9874daa4780')" :title2="language == 'en-US' ? '' : 'Telephone Number'" colspan="3:5">
              <!-- {{ getData.basalInfo.telephoneNumber }} -->
              <!-- rohs宣告表的加密字段 -->
              <Encryption :encData="getData.basalInfo.telephoneNumberDecrypt" :encKey="getData.basalInfo.telephoneNumber"
              :supplyData="{supplyCode:getData.basalInfo.supplyCode,supplyName:getData.basalInfo.contactPerson}" :name="'宣告表'"></Encryption>
            </report-td>
            <report-td :title="h_i18n('7650487a8758fd50c87d6c9cff0aa5ac')" :title2="language == 'en-US' ? '' : 'Address'" colspan="3:5">
              <!-- {{ getData.basalInfo.address }} -->
              <!-- rohs宣告表的加密字段 -->
              <Encryption :encData="getData.basalInfo.addressDecrypt" :encKey="getData.basalInfo.address"
              :supplyData="{supplyCode:getData.basalInfo.supplyCode,supplyName:getData.basalInfo.contactPerson}" :name="'宣告表'"></Encryption>
            </report-td>
            <report-td :title="h_i18n('5d73c09499a08557279f7554a0837404')" :title2="language == 'en-US' ? '' : 'Apply for factory audit'" colspan="3:5">{{ getData.basalInfo.auditFactory }}</report-td>
          </tr>
          <tr>
            <report-td :title="h_i18n('1b9b4711fd9584e570c22e0d2ae70b0b')" :title2="language == 'en-US' ? '' : 'Special code for the same material composition'" colspan="6:6">
              {{ getData.basalInfo.relatedMtlNo }}
            </report-td>
            <report-td :title="h_i18n('a1323cc265292654b418fd3ea7509701')" :title2="language == 'en-US' ? '' : 'Supply For'" colspan="6:6">
              {{ getData.basalInfo.supplyFor }}
            </report-td>
          </tr>
        </form-body>

        <form-body v-if="value===h_i18n('2a6ba6309f86aadbbad3718136bd5c31')" class="form_table_style">
          <tr>
            <td colspan="24">
              <h-button-group style="padding-bottom:10px" v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
                <h-button type="primary" @click="uploadBtn">{{ h_i18n('8d9a071ee2ef45e045968e117a205c07') }}</h-button>
                <h-button type="primary" @click="addOne">{{ h_i18n('491411e0ae5d09d5eca25a2b2f275e3b') }}</h-button>
                <h-button type="primary" @click="deleteRow">{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</h-button>
                <h-button type="primary" @click="upOne">{{ h_i18n('8347a927c09a4ec2fe473b0a93f667d0') }}</h-button>
                <h-button type="primary" @click="exportCode">{{ h_i18n('9f99aead0942f4af9d3f470e5a53a30c') }}</h-button>
              </h-button-group>
              <h-button-group style="padding-bottom:10px" v-else>
                <h-button type="primary" @click="exportBtn">{{ h_i18n('1190e465f92cd349663a4f039d1548fb') }}</h-button>
              </h-button-group>
              <el-table :empty-text="h_i18n('4679ffa33e394e4f42ab24f0d8e87c28')" v-loading="data.tableLoading" height="100%" ref="tableRef"
                @selection-change="listCheckBoxChange" border :data="data.dataOfTable" size="small" cell-class-name="table_cell_style"
                  style="width: 100%; min-height: 140px;" :row-class-name="tableRowClassName" class="c_table_style print_style">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column type="index" :label="h_i18n('0fed9b4202906fda4163ff933c720d3c')" width="40" class-name="c_table_th_style"></el-table-column>
                <el-table-column prop="" :label="h_i18n('38fb2c29b97df521966a02700df60a8e')" width="" class-name="c_table_th_style">
                  <el-table-column prop="componentName" :label="h_i18n('d0b1c375d0db90c02e085d4ccafccc10')" min-width="90"></el-table-column>
                  <el-table-column prop="componentSpecification" :label="h_i18n('5bee2cbf1c40d6fb99695f9e8ce9032c')" min-width="150"></el-table-column>
                  <el-table-column prop="componentSupplier" :label="h_i18n('08b6c0f71ee1e8e9a8204fd233635417')" min-width="90"></el-table-column>
                  <el-table-column prop="componentQuantity" :label="h_i18n('eb83d6aba5c2c415f03a1f8aee74b5be')" min-width="90"></el-table-column>
                  <el-table-column prop="componentWeight" :label="h_i18n('466a2590436cfdcab94118038f193387')" min-width="90" class-name="c_table_th_style"></el-table-column>
                </el-table-column>
                <el-table-column prop="" :label="h_i18n('c7de2e3478b63313d3a2ea4af705d379')" width="" class-name="c_table_th_style">
                  <el-table-column prop="homegenousName" :label="h_i18n('d0b1c375d0db90c02e085d4ccafccc10')" min-width="90"></el-table-column>
                  <el-table-column prop="homegenousSpecification" :label="h_i18n('5bee2cbf1c40d6fb99695f9e8ce9032c')" min-width="150"></el-table-column>
                  <el-table-column prop="homegenousWeight" :label="h_i18n('466a2590436cfdcab94118038f193387')" min-width="90" class-name="c_table_th_style"></el-table-column>
                </el-table-column>
                <el-table-column prop="" :label="h_i18n('42d031140481a7fb0b9170f9e7975da7')" width="" class-name="c_table_th_style">
                  <el-table-column prop="belongTo" :label="h_i18n('d19b97d1b680f9fff517aa87b3dd4bb0')" min-width="260"></el-table-column>
                  <el-table-column prop="testDepartment" :label="h_i18n('6a4b4cae25dafa30c8b0b1c12a8d7f8e')" min-width="150"></el-table-column>
                  <el-table-column prop="testReportNumber" :label="h_i18n('11661e826a2e94ccf98fb3454ca826cc')" min-width="180"></el-table-column>
                  <el-table-column prop="fileName" :label="h_i18n('a381566d434103ac8ae72ba424e60612')" min-width="170">
                    <template #default="{ row,$index }">
                      <span style="color:#2164F5;text-decoration:none ;cursor:pointer;" @click="getFile(row,$index)"
                        v-if="row.testDepartment && !row.fileUuid && (kindType == 'sqmModify'||kindType == 'sqmAdd')">{{ h_i18n('0063c51e228e58fddadbff82a79cf3c0') }}</span>
                      <span style="color:#2164F5;cursor: pointer;text-overflow: ellipsis;overflow: hidden;display:block;" @click="fileDown(row.fileUuid,row.fileName)"
                        v-if="row.fileUuid">{{ row.fileName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reportDate" :label="h_i18n('146d232cc075b490b8f37837aeee912b')" min-width="120">
                    <template #default="{ row }">
                      <span>{{ time(row.reportDate) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="expriryTime" :label="h_i18n('0abeeb8fd90f9152522997c9a44b58f7')" min-width="120" class-name="c_table_th_style">
                    <template #default="{ row }">
                      <span>{{ time(row.expriryTime) }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column prop="" :label="h_i18n('cf56e4fc36a86482c47781c7068f18a2')" width="" class-name="c_table_th_style">
                  <el-table-column prop="pb" :label="'Pb'" min-width="60"></el-table-column>
                  <el-table-column prop="cd" :label="'Cd'" min-width="60"></el-table-column>
                  <el-table-column prop="hg" :label="'Hg'" min-width="60"></el-table-column>
                  <el-table-column prop="cr" :label="h_i18n('454435f8e0405217d547f97bb0af100f')" min-width="60"></el-table-column>
                  <el-table-column prop="pbb" :label="'PBB'" min-width="60"></el-table-column>
                  <el-table-column prop="pbde" :label="'PBDE'" min-width="60"></el-table-column>
                  <el-table-column prop="dehp" :label="'DEHP'" min-width="60"></el-table-column>
                  <el-table-column prop="dbp" :label="'DBP'" min-width="60"></el-table-column>
                  <el-table-column prop="bbp" :label="'BBP'" min-width="60"></el-table-column>
                  <el-table-column prop="dipb" :label="'DIBP'" min-width="60" class-name="c_table_th_style"></el-table-column>
                </el-table-column>
                <el-table-column prop="exemption" :label="h_i18n('44cb4c4e9206b52b506d7265bc2f54e8')" width="90"></el-table-column>
              </el-table>

              <el-table :empty-text="h_i18n('4679ffa33e394e4f42ab24f0d8e87c28')" v-loading="data.tableLoading" :fit="false" width="100%"
                @selection-change="listCheckBoxChange" border :data="data.dataOfTable" size="small" stripe
                  style="" :row-class-name="tableRowClassName" class="print_show_style">
                <!-- <el-table-column type="selection" min-width="4%"></el-table-column> -->
                <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="3%"></el-table-column>
                <el-table-column prop="" :label="h_i18n('e364f0695cbaefb34ec6f82487cc3503')" min-width="21%">
                  <el-table-column prop="componentName" :label="h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5')" min-width="4%"></el-table-column>
                  <el-table-column prop="componentSpecification" :label="h_i18n('6ad1b6e0043132e6ae3f8a83487836bb')" min-width="5%"></el-table-column>
                  <el-table-column prop="componentSupplier" :label="h_i18n('bab268d5468de413a7158920799e354d')" min-width="4%"></el-table-column>
                  <el-table-column prop="componentQuantity" :label="h_i18n('0bf60b32f9db93b87e08763b1c815469')" min-width="4%"></el-table-column>
                  <el-table-column prop="componentWeight" :label="h_i18n('fcd9436296f1a4b17e75892d0dd4e5a0')" min-width="4%"></el-table-column>
                </el-table-column>
                <el-table-column prop="" :label="h_i18n('6c29d4ed37f89101dfb74f516187d05c')" min-width="13%">
                  <el-table-column prop="homegenousName" :label="h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5')" min-width="4%"></el-table-column>
                  <el-table-column prop="homegenousSpecification" :label="h_i18n('6ad1b6e0043132e6ae3f8a83487836bb')" min-width="5%"></el-table-column>
                  <el-table-column prop="homegenousWeight" :label="h_i18n('fcd9436296f1a4b17e75892d0dd4e5a0')" min-width="4%"></el-table-column>
                </el-table-column>
                <el-table-column prop="" :label="h_i18n('a53a82c8bf8fd124b587b26bcfad50cf')" min-width="30%">
                  <el-table-column prop="belongTo" :label="h_i18n('c4f0fba1ac12ee233a6b0c1783d5a771')" min-width="5%"></el-table-column>
                  <el-table-column prop="testDepartment" :label="h_i18n('4e20e078c1d3a0805446e70bd8b4400b')" min-width="5%"></el-table-column>
                  <el-table-column prop="testReportNumber" :label="h_i18n('0877751ad0ca9072aad13edca6d986d1')" min-width="5%"></el-table-column>
                  <el-table-column prop="fileName" :label="h_i18n('74dbfb5126af971d4b5955e3247199d3')" min-width="5%"></el-table-column>
                  <el-table-column prop="reportDate" :label="h_i18n('75cd7f22e38d44007e8ccacf06715b85')" min-width="5%">
                    <template #default="{ row }">
                      <span>{{ time(row.reportDate) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="expriryTime" :label="h_i18n('6460f46b3607ac4b78225902f085048d')" min-width="5%">
                    <template #default="{ row }">
                      <span>{{ time(row.expriryTime) }}</span>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column prop="" :label="h_i18n('54652da1d2833157982155fceb688813')" min-width="30%">
                  <el-table-column prop="pb" label="Pb" min-width="3%"></el-table-column>
                  <el-table-column prop="cd" label="Cd" min-width="3%"></el-table-column>
                  <el-table-column prop="hg" label="Hg" min-width="3%"></el-table-column>
                  <el-table-column prop="cr" label="Cr" min-width="3%"></el-table-column>
                  <el-table-column prop="pbb" label="PBB" min-width="3%"></el-table-column>
                  <el-table-column prop="pbde" label="PBDE" min-width="3%"></el-table-column>
                  <el-table-column prop="dehp" label="DEHP" min-width="3%"></el-table-column>
                  <el-table-column prop="dbp" label="DBP" min-width="3%"></el-table-column>
                  <el-table-column prop="bbp" label="BBP" min-width="3%"></el-table-column>
                  <el-table-column prop="dipb" label="DIBP" min-width="3%"></el-table-column>
                </el-table-column>
                <el-table-column prop="exemption" :label="h_i18n('5135b5a91526f3e49c5e8638f7852f58')" min-width="3%"></el-table-column>
              </el-table>
            </td>
          </tr>
        </form-body>

        <form-body v-if="value===h_i18n('ff2db8c65fc3486eb9363385e140ea66')">
          <tr>
            <td colspan="24" style="border-right:1px solid #ccc;border-bottom:1px solid #ccc;">
              <div style="font-size:14px;padding: 5px;">{{ h_i18n('82b1fc74a306980b7cff7450034dbd05') }}<br/>
                <span class="print_style">
                  It is hereby guaranteed that:
                </span>
                <br/>{{ h_i18n('f48e5f1fdb1928fc7a7a8fc016912c55') }}<br class="print_style"/>
                <span class="print_style">
                  The products in this Product/Component Declaration("Declaration") are supplied to Haier subsidiaries("Haier") directly by our company or through a third party. This Declaration is true and accurate. We will be fully responsible for any consequences caused by any misrepresentation in the Declaration and will indemnify Haier from any and all losses including but not limited to penality, costs and expenses.
                </span>
                <br class="print_style"/>{{ h_i18n('3f7e951c643367479b1ce10378b854aa') }}<br/>
                <span class="print_style">
                  Any revision to this declaration will be subject to Haier's confirmation. If the form is not revised or such revision is not confirmed according to the changes in supplied materials in a timely manner, we shall take the liability for breach of agreement according to General Supplier Contract and compensate Haier for any and all its losses in relation to the misrepresentation in this Declaration.         
                </span>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="24" style="border-right:1px solid #ccc;border-bottom:1px solid #ccc;">
              <div style="font-size:14px;padding: 5px;">{{ h_i18n('f6349c441652f0e053dcde768d5c3db8') }}<span class="print_style">Note</span>{{ h_i18n('dec8928f8c698032440ce2ecbca10247') }}<br/>{{ h_i18n('84c5937d98cd93e19a20c644fff24a57') }}<br/>
                <span class="print_style">
                  1.The restricted materials in this declaration refer to the hazardous substances prescribed by EU RoHS, that is, 1)Pb and its compunds 2)Cd and its compounds 3)Hg and its compounds 4)Cr6+ compunds 5)PBB and PBDE
                </span>
                <br class="print_style"/>{{ h_i18n('4ebc1644c19a819266f8b7c5c186e2b7') }}<br/>
                <span class="print_style">
                  2.Exemptions in RoHS are excluded.
                </span>
                <br class="print_style"/>{{ h_i18n('bc75f2eb9f4ff9e29ff7db906eb22914') }}<br/>
                <span class="print_style">
                  3.Homogeneous materials in this Declaration refer to every ingredient of product composition.That can be either single compound or mixture. For example, as for coated screw, the coating and the core metal are two homogeneous materials.
                </span>
                <br class="print_style"/>{{ h_i18n('5219f6e08a8e773b382df345d5fdb3a5') }}<br/>
                <span class="print_style">
                  4. Test reports of homogeneous materials containing the restricted materials are required.
                </span>
                <br class="print_style"/>{{ h_i18n('776065a22e359dfc4b2763a454088c15') }}<br/>
                <span class="print_style">
                  5.This declaration must be submitted to R&D Division or Product Division for review before products/components are supplied.
                </span>
                <br class="print_style"/>{{ h_i18n('3ca51337bf18829e74c77e6697515dcc') }}<br/>
                <span class="print_style">
                  6.The above mentioned declaration form are written in Chinese and English,the Chinese version is the official version.
                </span>
              </div>
            </td>
          </tr>
          <tr v-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
            <td style="height:41px;" :last-line="false" colspan="24"><sup style="color:red">*</sup>{{ h_i18n('dbcf806fc5b0f1478c92e7d278b4052c') }}<el-radio-group disabled v-model="getData.basalInfo.isPromise" v-if="data.overruleType == 1">
                <el-radio label="1">{{ h_i18n('e61f2cc4c39244f627b20e18788c3890') }}</el-radio>
                <el-radio label="2">{{ h_i18n('7173f80900ea2ff9fec6568115611305') }}</el-radio>
              </el-radio-group>
              <el-radio-group v-model="postData.isPromise" v-else>
                <el-radio label="1">{{ h_i18n('e61f2cc4c39244f627b20e18788c3890') }}</el-radio>
                <el-radio label="2">{{ h_i18n('7173f80900ea2ff9fec6568115611305') }}</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr v-if="kindType == 'sqmDetail' || kindType == 'hmqmDetail'" class="print_style">
            <td style="height:41px;" :last-line="false" colspan="24">{{ h_i18n('dbcf806fc5b0f1478c92e7d278b4052c') }}<el-radio-group disabled v-model="getData.basalInfo.isPromise">
                <el-radio label="1">{{ h_i18n('e61f2cc4c39244f627b20e18788c3890') }}</el-radio>
                <el-radio label="2">{{ h_i18n('7173f80900ea2ff9fec6568115611305') }}</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr v-if="kindType == 'sqmModify' && data.overruleType != 1">
            <td style="height:41px;" :last-line="false" colspan="24">{{ h_i18n('83dc2f2474e78bf6447f06365c0d0660') }}<el-radio-group v-model="postData.isSupply">
                <el-radio label="1">{{ h_i18n('92dcbd51deeff39d0d37fd5323ef687e') }}</el-radio>
                <el-radio label="2">{{ h_i18n('8c739155cca4152c2123073ae7e05da1') }}</el-radio>
              </el-radio-group>
            </td>
          </tr>
        </form-body>
        <form-body v-if="value===h_i18n('d55f68b34049519d2805a2bd7dc49bca') && ( kindType == 'sqmDetail' || kindType == 'hmqmDetail')" class="form_table_style print_style">
          <tr>
            <td colspan="24">
              <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" v-loading="data.auditTableLoading" height="100%" cell-class-name="table_cell_style"
                    border :data="data.auditDataTable" size="small" style="width: 100%; min-height: 140px">
                <el-table-column prop="role" :label="h_i18n('464f3d4ea36eda2f87d65f7b2f4564cf')" min-width="120"></el-table-column>
                <el-table-column prop="name" :label="h_i18n('60d0458ac6ebef0fff1331af196b3c82')" min-width="90"></el-table-column>
                <el-table-column prop="time" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170">
                  <template #default="{ row }">
                    <span>{{ time(row.time,6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="result" :label="h_i18n('9d52b787ab5763e315d50e5f40645c94')" min-width="100">
                  <template #default="{ row }">
                    <span v-if="row.result == '1'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
                    <span v-else-if="row.result == '2'">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="opinion" :label="h_i18n('a6396f13c260444d561afaa9407467be')" min-width="200"></el-table-column>
              </el-table>
            </td>
          </tr>
        </form-body>
        <form-body v-if="value===h_i18n('d55f68b34049519d2805a2bd7dc49bca') &&  kindType == 'sqmModify' && data.overruleType == 1" class="form_table_style print_style">
          <tr>
            <td colspan="24">
              <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" v-loading="data.auditTableLoading" height="100%" cell-class-name="table_cell_style"
                    border :data="data.auditDataTable" size="small" style="width: 100%; min-height: 140px">
                <el-table-column prop="role" :label="h_i18n('464f3d4ea36eda2f87d65f7b2f4564cf')" min-width="120"></el-table-column>
                <el-table-column prop="name" :label="h_i18n('60d0458ac6ebef0fff1331af196b3c82')" min-width="90"></el-table-column>
                <el-table-column prop="time" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170">
                  <template #default="{ row }">
                    <span>{{ time(row.time,6) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="result" :label="h_i18n('9d52b787ab5763e315d50e5f40645c94')" min-width="100">
                  <template #default="{ row }">
                    <span v-if="row.result == '1'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
                    <span v-else-if="row.result == '2'">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="opinion" :label="h_i18n('a6396f13c260444d561afaa9407467be')" min-width="200"></el-table-column>
              </el-table>
            </td>
          </tr>
        </form-body>
        <form-body v-if="value===h_i18n('3b69c28ccfe587be48a621c1d2e380de') && ( kindType == 'sqmAudit' || kindType == 'hmqmAudit')" class="form_table_style">
          <tr>
            <td colspan="24">
              <el-table :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')" v-loading="data.auditTableLoading" height="100%" cell-class-name="table_cell_style"
                    border :data="data.auditDataTable" size="small" style="width: 100%; min-height: 140px">
                <el-table-column prop="role" :label="h_i18n('464f3d4ea36eda2f87d65f7b2f4564cf')" min-width="120"></el-table-column>
                <el-table-column prop="name" :label="h_i18n('60d0458ac6ebef0fff1331af196b3c82')" min-width="90"></el-table-column>
                <el-table-column prop="time" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170">
                  <template #default="{ row }">
                    <!-- <span v-if="$index == 1 && data.roleCode == 'S006' && kindType == 'sqmAudit'">
                      {{ postData.auditTwoDate }}
                    </span>
                    <span v-else-if="$index == 2 && kindType == 'hmqmAudit'">
                      {{ postData.checkTime }}
                    </span> -->
                    <span>
                      {{ time(row.time,6) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="" :label="h_i18n('9d52b787ab5763e315d50e5f40645c94')" min-width="100">
                  <template #default="{ row , $index}">
                    <el-select v-if="$index == 1 && data.roleCode == 'S006' && kindType == 'sqmAudit'" v-model="postData.auditTwoStatus">
                      <el-option value="1" :label="h_i18n('23c1f39900b3af4c3263449782e288e1')"></el-option>
                      <el-option value="2" :label="h_i18n('32525478cd5c1c93de9c71246021b595')"></el-option>
                    </el-select>
                    <el-select v-else-if="$index == 2 && kindType == 'hmqmAudit'" v-model="postData.checkStatus">
                      <el-option value="1" :label="h_i18n('23c1f39900b3af4c3263449782e288e1')"></el-option>
                      <el-option value="2" :label="h_i18n('32525478cd5c1c93de9c71246021b595')"></el-option>
                    </el-select>
                    <template v-else>
                      <span v-if="row.result == '1'">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
                      <span v-else-if="row.result == '2'">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</span>
                    </template> 
                  </template>
                </el-table-column>
                <el-table-column :label="h_i18n('a6396f13c260444d561afaa9407467be')" min-width="200">
                  <template #default="{ row , $index}">
                    <el-input v-if="$index == 1 && data.roleCode == 'S006' && kindType == 'sqmAudit'"
                    v-model="postData.auditTwoMark" maxlength="500">
                    </el-input>
                    <el-input v-else-if="$index == 2 && kindType == 'hmqmAudit'" v-model="postData.checkMark"
                    maxlength="500">
                    </el-input>
                    <span v-else>
                      {{ row.opinion }}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </td>
          </tr>
        </form-body>
      </template>
      <template #footer>
        <h-button-group align="center">
          <h-button type="primary" v-if="postData.isSupply == '2'" @click="invalid" :loading="deleteLoading">{{ h_i18n('c4a4d9f768737d3d24002eed65a3cbed') }}</h-button>
          <h-button type="primary" v-else-if="kindType == 'sqmAudit' || kindType == 'hmqmAudit'" @click="audit" :loading="auditLoading">{{ h_i18n('cf13b1a67881f454af469aa874f087e5') }}</h-button>
          <template v-else-if="kindType == 'sqmAdd' || kindType == 'sqmModify'">
            <h-button type="primary" @click="save" :loading="saveLoading">{{ h_i18n('8d7d46cc7ee94f393a02f3dae9fdd2bd') }}</h-button>
            <h-button type="primary" @click="submit" :loading="subLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          </template>
          <h-button type="primary" v-else-if="kindType == 'sqmDetail' && data.auditDataTable[2]?.result == '1'" @click="print"
            class="print_style">{{ h_i18n('f26ef914245883c80f181c4aade2ed04') }}</h-button>
          <h-button type="primary" v-else @click="back">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </form-area>
    <h-dialog :title="data.addOrUp == 'up' ? h_i18n('8347a927c09a4ec2fe473b0a93f667d0') : h_i18n('66ab5e9f24c8f46012a25c89919fb191')" :show="data.dialogShow" footer class="add_dialog_style"
      @close="closeDialogBtn">
      <hBBT :title="h_i18n('e364f0695cbaefb34ec6f82487cc3503')"></hBBT>
        <div class="row-div-style">

          <h-top-search :title="h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.componentName"
              :content="h_i18n('df09fff77b4bb5a0b77d3108072fccb4')">
              
              <el-input v-model="saveData.componentName" @mouseenter="tip.componentName = false" clearable></el-input>
            </el-tooltip>
          </h-top-search>
        
          <h-top-search :title="h_i18n('6ad1b6e0043132e6ae3f8a83487836bb')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.componentSpecification"
              :content="h_i18n('9c6c87ac4ee0fb7d652535a653613145')">
              <el-input v-model="saveData.componentSpecification" @mouseenter="tip.componentSpecification = false" clearable></el-input>
              
            </el-tooltip>
          </h-top-search>
       
          <h-top-search :title="h_i18n('bab268d5468de413a7158920799e354d')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.componentSupplier"
              :content="h_i18n('ec1943f1f52f36cf7857bbb5b4e4e903')">
              <el-input v-model="saveData.componentSupplier" @mouseenter="tip.componentSupplier = false" clearable></el-input>
              
            </el-tooltip>
          </h-top-search>
        
          <h-top-search :title="h_i18n('0bf60b32f9db93b87e08763b1c815469')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.componentQuantity"
              :content="h_i18n('a3f9e82f130c79b34baf365549076989')">
              <el-input v-model="saveData.componentQuantity" @mouseenter="tip.componentQuantity = false" clearable></el-input>
              
            </el-tooltip>
          </h-top-search>

          <h-top-search :title="h_i18n('fcd9436296f1a4b17e75892d0dd4e5a0')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.componentWeight"
              :content="h_i18n('72b78760aed1e31a5ebba3c994aa7df3')">
              <el-input v-model="saveData.componentWeight" @mouseenter="tip.componentWeight = false" clearable></el-input>
              
            </el-tooltip>
          </h-top-search>
        </div>
        
      <hBBT :title="h_i18n('a53a82c8bf8fd124b587b26bcfad50cf')"></hBBT>
        <div class="row-div-style">
          
          <h-top-search :title="h_i18n('0877751ad0ca9072aad13edca6d986d1')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.testReportNumber"
              :content="h_i18n('4ef63fb2a0766fd993aeb383bd1bdbb7')">
              <div></div>
            </el-tooltip>
            <!-- <el-select v-model="saveData.testReportNumber" clearable filterable remote @change="testReportNumberChange"
              :remote-method="testReportNumberListRemoteMethod" @mouseenter="tip.testReportNumber = false"> -->
            <!-- <el-select v-model="saveData.testReportNumber" clearable filterable remote @change="testReportNumberChange"
               @mouseenter="tip.testReportNumber = false" :remote-method="testReportNumberListRemoteMethod"> -->
            <el-select v-model="saveData.testReportNumber" clearable filterable @change="testReportNumberChange"
               @mouseenter="tip.testReportNumber = false">
              <el-option v-for="item in data.testReportNumberList" :key="item.id" :value="item.testReportNumber" :label="item.testReportNumber">
                <span style="float: left">{{ item.testReportNumber }}</span><span>-{{ item.testDepartment }}</span>
              </el-option>
            </el-select>
          </h-top-search>
        
          <h-top-search :title="h_i18n('337bffab47e921014ae18dea50127fae')">
            <!-- <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.homegenousNo"
              content="检测数据不能为空">
              
            </el-tooltip> -->
            <el-select v-model="saveData.homegenousNo" clearable filterable :placeholder="h_i18n('eb5bab1c31ce64e52ed71628cd7a0b14')" @change="homegenousNoChange"
              >
              <el-option v-for="item in data.homegenousNoList" :key="item.id" :value="item.id" :label="h_i18n('6eee825d69261f9df2e56f53befb461c')+item.id+h_i18n('fea1089a3aea5e70f7c643e11a1da5fc')+item.homegenousName"></el-option>
            </el-select>
          </h-top-search>
        
          <h-top-search :title="h_i18n('c4f0fba1ac12ee233a6b0c1783d5a771')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.belongTo"
              :content="h_i18n('900378aa37c9ed3f6a129abbb983fa68')">
              <el-input v-model="saveData.belongTo" @mouseenter="tip.belongTo = false" clearable></el-input>
              
            </el-tooltip>
          </h-top-search>
        
          <h-top-search :title="h_i18n('4e20e078c1d3a0805446e70bd8b4400b')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.testDepartment"
              :content="h_i18n('74d4e28a9e43e36aaa5aee0c97fec3c6')">
              <el-input v-model="saveData.testDepartment" @mouseenter="tip.testDepartment = false" clearable></el-input>
              
            </el-tooltip>
          </h-top-search>
        </div>
        
      
        

      <hBBT :title="h_i18n('6c29d4ed37f89101dfb74f516187d05c')"></hBBT>
      <div class="row-div-style">
        
          <h-top-search :title="h_i18n('d7ec2d3fea4756bc1642e0f10c180cf5')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.homegenousName"
              :content="h_i18n('df09fff77b4bb5a0b77d3108072fccb4')">
              
              <el-input v-model="saveData.homegenousName" @mouseenter="tip.homegenousName = false" clearable></el-input>
            </el-tooltip>
          </h-top-search>
        
          <h-top-search :title="h_i18n('6ad1b6e0043132e6ae3f8a83487836bb')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.homegenousSpecification"
              :content="h_i18n('9c6c87ac4ee0fb7d652535a653613145')">
              
              <el-input v-model="saveData.homegenousSpecification" @mouseenter="tip.homegenousSpecification = false" clearable></el-input>
            </el-tooltip>
          </h-top-search>
        
          <h-top-search :title="h_i18n('fcd9436296f1a4b17e75892d0dd4e5a0')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.homegenousWeight"
              :content="h_i18n('72b78760aed1e31a5ebba3c994aa7df3')">
              
              <el-input v-model="saveData.homegenousWeight" @mouseenter="tip.homegenousWeight = false" clearable 
                @input="homegenousWeightInput"></el-input>
            </el-tooltip>
          </h-top-search>
        
      </div>

      <hBBT :title="h_i18n('54652da1d2833157982155fceb688813')"></hBBT>
      <div class="row-div-style">
        
          <h-top-search title="Pb" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.pb"
              :content="h_i18n('1e876ebd0e60c8d3b5e4310ee97da2e6')">
              
              <el-input v-model="saveData.pb" clearable @mouseenter="tip.pb = false"></el-input>
            </el-tooltip>
          </h-top-search>
        
          <h-top-search title="Cd" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.cd"
              :content="h_i18n('9bce6eed8e61c50e6a308db6efb8eec1')">
              
              <el-input v-model="saveData.cd" clearable @mouseenter="tip.cd = false"></el-input>
            </el-tooltip>
          </h-top-search>
        
          <h-top-search title="Hg" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.hg"
              :content="h_i18n('f3392f5e32649d1e9dee3ea57d93f4cf')">
              
              <el-input v-model="saveData.hg" clearable @mouseenter="tip.hg = false"></el-input>
            </el-tooltip>
          </h-top-search>
        
          <h-top-search :title="h_i18n('7cd7385150917ce56762eb49d1e6504a')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.cr"
              :content="h_i18n('966fd5a58f83f1246132a0b7e67bbf25')">
              
              <el-input v-model="saveData.cr" clearable @mouseenter="tip.cr = false"></el-input>
            </el-tooltip>
          </h-top-search>

          <h-top-search title="PBB" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.pbb"
              :content="h_i18n('b461f8eef0d9f39d4b6632f3a8be590c')">
              
              <el-input v-model="saveData.pbb" clearable @mouseenter="tip.pbb = false"></el-input>
            </el-tooltip>
          </h-top-search>
        
      </div>
      <div class="row-div-style">

            <h-top-search title="PBDE" required>
              <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.pbde"
                :content="h_i18n('5344c1bd2a5f3baab6bce5efe4ae29a2')">
                
                <el-input v-model="saveData.pbde" clearable @mouseenter="tip.pbde = false"></el-input>
              </el-tooltip>
            </h-top-search>
          
            <h-top-search title="DEHP" required>
              <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.dehp"
                :content="h_i18n('b0e555e7cab26e6f025020a8a9c02d73')">
                
                <el-input v-model="saveData.dehp" clearable @mouseenter="tip.dehp = false"></el-input>
              </el-tooltip>
            </h-top-search>
          
            <h-top-search title="DBP" required>
              <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.dbp"
                :content="h_i18n('af0051d3757696914baa4d2e4ce7ee5b')">
                
                <el-input v-model="saveData.dbp" clearable @mouseenter="tip.dbp = false"></el-input>
              </el-tooltip>
            </h-top-search>
          
            <h-top-search title="BBP" required>
              <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.bbp"
                :content="h_i18n('b8c602c247f2fd489b9b15350123858a')">
                
                <el-input v-model="saveData.bbp" clearable @mouseenter="tip.bbp = false"></el-input>
              </el-tooltip>
            </h-top-search>
            
            <h-top-search title="DIBP" required>
              <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.dipb"
                :content="h_i18n('8c781cf352eccd3c165b7d03e685ccc1')">
                
                <el-input v-model="saveData.dipb" clearable @mouseenter="tip.dipb = false"></el-input>
              </el-tooltip>
            </h-top-search>
      </div>
      <div class="row-div-style">
        
          <h-top-search :title="h_i18n('5135b5a91526f3e49c5e8638f7852f58')" required>
            <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="tip.exemption"
              :content="h_i18n('c0652a4d8a1bfdb69b751cf2630cfc25')">
              
              <el-input v-model="saveData.exemption" clearable @mouseenter="tip.exemption = false"></el-input>
            </el-tooltip>
          </h-top-search>
      </div>

      <template #footer>
        <h-button-group align="center">
          <h-button type="primary" @click="editBtn" v-if="data.addOrUp == 'add'" :loading="data.editBtnLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button type="primary" @click="upDateBtn" v-if="data.addOrUp == 'up'" :loading="data.editBtnLoading">{{ h_i18n('32ac152be1911e9360047dcb0898cf70') }}</h-button>
          <h-button type="default" @click="closeDialogBtn">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </h-dialog>
    <h-dialog :show="data.fileChoose" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" footer @close="data.fileChoose = false"
      width="752px">
      <el-row>
        <div style="color:red;font-size:14p;line-height:28px;padding-left: 28px;">{{ h_i18n('3322de466da57d677d5bcb4cd7fe93be') }}</div>
      </el-row>
      <el-row>
        <div style="color:red;font-size:14px;line-height:28px;padding-left: 28px;">{{ h_i18n('79213df16a7a6e0e1404c225567f48bc') }}</div>
      </el-row>
      <br/>
      <h-button type="primary" @click="getFileUuidAndFileName">{{ h_i18n('6a620e3c07048291fdb26b6edcee7aba') }}</h-button>
      <span style="color:#2164F5;text-decoration:none ;cursor:pointer;padding-left:10px;font-size: 14px;display: inline-block;vertical-align: sub;"
        v-if="data.index >= 0 && data.dataOfTable[data.index].fileUuid && data.dataOfTable[data.index].fileName"
        @click="fileDown(data.dataOfTable[data.index].fileUuid,data.dataOfTable[data.index].fileName)">
        {{ data.dataOfTable[data.index].fileName }}</span>
  </h-dialog>
  <h-dialog :show="data.upLoadFlag" :title="h_i18n('8d9a071ee2ef45e045968e117a205c07')" footer @close="data.upLoadFlag = false"
      width="752px">
      <el-row>
        <div style="font-size:14px; color:rgb(74, 74, 74); line-height:20px;padding-bottom:20px;">{{ h_i18n('9f8f5cf9eb6881050c686cdf22f9297c') }}</div>
      </el-row>
      <el-row>
        <h-button-group align="center">
          <h-button type="primary" @click="downFile(h_i18n('带识别码'))">{{ h_i18n('ab502f7a6848989c4225e12e6a93609a') }}</h-button>
          <h-button type="primary" @click="downFile(h_i18n('不带识别码'))">{{ h_i18n('8b47eafbcaacab0760ad94363217b397') }}</h-button>
        </h-button-group>
      </el-row>
      <br/>
      <hc-file-upload download :delete="true" v-model="data.document" acceptOther="xls,xlsx"
        accept="other" size="30"
        :info="h_i18n('fbe425a5f5ee7451e425073054e82834')" @error="errorFile"
        @delete="deleteFun()" @download="download()"
        @change="fileChange">
      </hc-file-upload>
  </h-dialog>
  </h-form-page>


</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';
import { useStore } from 'vuex';
import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount,ref, onActivated, onDeactivated ,defineEmit, watch ,computed } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import Encryption from "@/components/Encryption"
const { proxy, ctx } = getCurrentInstance()
const route = useRoute()
const store = useStore();
const language = ref('')

const emit = defineEmit(
  ['submitBtn','backBtn','saveBtn','invalidBtn','auditBtn']
)

const props = defineProps({
  kindType: {
    type: String,
    default: ''
  },
  getData: {
    type:Object,
    default: {}
  },
  subLoading:{
    type:Boolean,
    default:false,
  },
  saveLoading:{
    type:Boolean,
    default:false,
  },
  auditLoading:{
    type:Boolean,
    default:false,
  },
  deleteLoading:{
    type:Boolean,
    default:false,
  }
})
const tableRef = ref({})

const data = reactive({
  auditFactoryList:[] , // 申请审核工厂列表
  dataOfTable:[],
  basalInfo:{},
  rowListOfCheck:[],
  addOrUp:'',
  dialogShow: false,
  editBtnLoading:false,
  auditTableLoading:false,
  tableLoading:false,
  auditDataTable:[], // 审核数据列表
  formTitle:[],
  fileChoose:false,
  index:undefined,
  upLoadFlag:false,
  document:{},
  basalLoading:false,
  testReportNumberList:[],
  testReportNumberListAll:[],
  homegenousNoList:[],
  relateId:'',
  upIndex:-1,
  overruleType:null,
  isSelect:false,
  selectLoading:false,
})
const tip = reactive({})
const saveData = ref({})
const postData = reactive({
  mtlNo:'',
})
// 校验电话号
const telephoneNumberInput = (v) => {
  // 获取输入的值
  let value = v
  // 只允许输入数字
  value = value.replace(/[^0-9]/g, '')
  // 更新输入框的值
  postData.telephoneNumber = value;
}
// 重量字段数字类型校验
const homegenousWeightInput = (v) => {
  console.log(v)
  // 获取输入的值
  let value = v
  // 只允许输入数字和小数点
  value = value.replace(/[^0-9.]/g, '')
  // 确保只有一个小数点
  value = value.replace(/(\..*)\./g, '$1')
  // 保留五位小数
  value = value.replace(/^(\d+)\.(\d{0,5}).*$/, '$1.$2')
  
  // 更新输入框的值
  saveData.value.homegenousWeight = value;
}
/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
const listCheckBoxChange = (rowArr) => {
  data.rowListOfCheck = rowArr
  // console.log(data.rowListOfCheck)
  // if(data.rowListOfCheck.length == 1){
  //   getTaskId()
  // }
};
// 本地列表 index
const tableRowClassName = (row,rowIndex) => {
// console.log("row,,,,,,,,,",row)
row.row.index = row.rowIndex
}
// 两个模糊查询相关
const http = reactive({
mtlSearchHttp: false,
supplySearchHttp: false,
});
const plan = reactive({
showMtlPlan: false,
planBlur: false,
MtlOver600: false,
SupplyOver600: false,
showSupplyPlan: false,
});

// 弹窗失焦
const detailBlur = (v) => {
if (!plan.planBlur) {
plan[v] = false;
}
if(postData.mtlNo){
  setTimeout(() => {
    if(!data.isSelect){
      if(postData.mtlNo.length < 4){
        proxy.$message({
          message: h_i18n('82cf9fc7681ec05069e43a426038b1ec'),
          type: 'warning',
        })
        postData.mtlNo = ''
      }else{
        proxy.$message({
          message: h_i18n('e438042cf0eee10d7843c9be1ac6665f'),
          type: 'warning',
        })
        postData.mtlNo = ''
      }
    }
  }, 200);
}
// console.log('关闭弹窗')
// changeMtl()
};
// 弹窗聚焦
const detailFocus = (v) => {
plan.planBlur = false;
if (v == "showSupplyPlan") {
if (postData.supplyCode.length >= 2) {
  plan[v] = true;
}
} else if (v == "showMtlPlan") {
if (postData.mtlNo.length >= 4) {
  plan[v] = true;
}
}
};
const clickMtlNo = (row) => {
postData.mtlNo = row.mtlNo;
plan.showMtlPlan = false;
postData.mtlName = row.mtlName
data.basalLoading = true
data.isSelect = true
// 校验专用号是否可以新增rohs
proxy.$http({
  url:`/base/newrohs/validateIfAdd?supplyCode=${postData.supplyCode}&mtlNo=${postData.mtlNo}`,
  method:'get',
}).then(res=>{
  if(res.data.data.queryFlag == '1'){
    proxy.info(h_i18n('a7101665af6b7f65cb9455c1dc5a0ec4'))
    postData.mtlNo = ''
    postData.mtlName = ''
    data.auditFactoryList = []
    clearPageData()
  }else if(res.data.data.queryFlag == '2'){
    proxy.info(h_i18n('b3287d15c220247d2423e691c41b9b86'))
    postData.mtlNo = ''
    postData.mtlName = ''
    data.auditFactoryList = []
    clearPageData()
  }else if(res.data.data.queryFlag == 'ok'){
    data.auditFactoryList = res.data.data.supplyForId.split(',').map((item,index)=>{
      // console.log({valueId:item,valueName:res.data.data.supplyFor.split(',')[index]})
      return {valueId:item,valueName:res.data.data.supplyFor.split(',')[index]}
    })
    postData.relatedMtlNo = res.data.data.relatedMtlNo
    postData.supplyFor = res.data.data.supplyFor
    postData.supplyForId = res.data.data.supplyForId
    postData.auditFactoryId = ''
    postData.auditFactory = ''
  }
}).catch(err=>{
  proxy.info(h_i18n('bfa45bbffb6e7b41ce5e08857a6ee16c'))
  postData.mtlNo = ''
  postData.mtlName = ''
}).finally(()=>{
  data.basalLoading = false
  setTimeout(() => {
    data.isSelect = false
  }, 500);
})
};
const clearPageData = () => {
  data.auditFactoryList = []
  postData.auditFactoryId = ''
  postData.auditFactory = ''
  postData.supplyFor = ''
  postData.relatedMtlNo = ''
}
const clickSupplierCode = (row) => {
postData.supplyCode = row.supplyCode;
plan.showSupplyPlan = false;
};
/**
* 专用号模糊查询
*/
const mtlNoChange = () => {
plan.planBlur = false;
if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
http.mtlSearchHttp = axios.CancelToken.source();
if (postData.mtlNo.length < 4) {
plan.showMtlPlan = false;
} else {
plan.showMtlPlan = true;
data.mtlLoading = true;
proxy
  .$http({
    method: "get",
    url: `/base/newrohs/getMtlnos?supplyCode=${postData.supplyCode}&mtlNo=${postData.mtlNo}`,
    headers: { "content-type": "application/json" },
    cancelToken: http.mtlSearchHttp.token,
  })
  .then((res) => {
    data.mtlNoList = res.data.data;
    if (data.mtlNoList.length >= 600) {
      plan.MtlOver600 = true;
      data.mtlLoading = false;
    }else if(data.mtlNoList.length == 0){
      proxy.info(h_i18n('573c8985ecd7b31c465015fc3327f997'))
      postData.mtlNo = ''
      postData.mtlName = ''
    } else {
      plan.MtlOver600 = false;
      data.mtlLoading = false;
    }
  })
  .catch((e) => {
    
   }).finally(()=>{
    // changeMtl()
   })
}
};
// 两个模糊查询结束
// 手动增加 查询测试报告编号
const testReportNumberListRemoteMethod = (query) => {
if(query){
  // isEffect 生效状态 1 生效
  proxy.$http({
    url:`/base/newrohs/getROHSReportEffectInfo`,
    method:'post',
    data:{
      testReportNumber:query,
      isEffect:1,
      pageNo:0,
      supplyCode:data.supplyCode
    }
  }).then(res=>{
    data.testReportNumberList = res.data.data.records
  }).catch(err=>{
    data.testReportNumberList = []
  }).finally(()=>{
    
  })
}else{
  testReportNumberListFirst()
}
}
// 默认载入一次测试报告编号
const testReportNumberListFirst = () => {
proxy.$http({
  url:`/base/newrohs/getROHSReportEffectInfo`,
  method:'post',
  data:{
    testReportNumber:'',
    isEffect:1,
    pageNo:0,
    supplyCode:data.supplyCode
  }
}).then(res=>{
  data.testReportNumberList = res.data.data.records
  data.testReportNumberListAll = res.data.data.records
}).catch(err=>{
  data.testReportNumberList = []
}).finally(()=>{
  
})
}

// 选中测试报告
const testReportNumberChange = (v) => {
if(!v){
  saveData.value.testDepartment = ''
  saveData.value.belongTo = ''
  // testReportNumberListFirst()
}
data.homegenousNoList = []

saveData.value.homegenousNo = ''
saveData.value.homegenousName = ''
saveData.value.homegenousSpecification = ''
saveData.value.homegenousWeight = ''
saveData.value.pb = ''
saveData.value.cd = ''
saveData.value.hg = ''
saveData.value.cr = ''
saveData.value.pbb = ''
saveData.value.pbde = ''
saveData.value.dehp = ''
saveData.value.dbp = ''
saveData.value.bbp = ''
saveData.value.dipb = ''
saveData.value.exemption = ''

data.testReportNumberList.some(item=>{
  if(item.testReportNumber == v){
    saveData.value.testDepartment = item.testDepartment
    saveData.value.belongTo = item.belongTo
    saveData.value.id = item.id
    saveData.value.fileName = item.fileName
    saveData.value.fileUuid = item.fileUuid
    saveData.value.expriryTime = new Date(item.expriryTime).toUTCString()
    saveData.value.reportDate = new Date(item.reportDate).toUTCString()
    // console.log(saveData.value.expriryTime)
    // console.log(saveData.value.reportDate)
    
    homegenousNoListRemoteMethod()
  }
  return item.testReportNumber == v
})
console.log(v,saveData.value.testReportNumber)
}
// 手动增加 查询检测数据
const homegenousNoListRemoteMethod = () => {
// console.log(saveData.value)
if(saveData.value.testReportNumber){
  let object = data.testReportNumberListAll.find(item=>{
    return item.testReportNumber == saveData.value.testReportNumber
  })
  if(object){
    saveData.value.id = object.id
  }
}
if(saveData.value.id){
  data.selectLoading = true
  proxy.$http({
    url:`/base/newrohs/queryCheckDateList`,
    method:'post',
    data:{
      fixConfig:true,
      relateId: saveData.value.id 
    }
  }).then(res=>{
    data.homegenousNoList = res.data.data
  }).catch(err=>{

}).finally(()=>{
  data.selectLoading = false
})
}
}
// 选中检测数据
const homegenousNoChange = (v) => {
data.homegenousNoList.some(item=>{
  if(item.id == v){
    saveData.value.homegenousName = item.homegenousName
    saveData.value.homegenousSpecification = item.homegenousSpecification
    saveData.value.homegenousWeight = item.homegenousWeight

    saveData.value.pb = item.pb
    saveData.value.cd = item.cd
    saveData.value.hg = item.hg
    saveData.value.cr = item.cr
    saveData.value.pbb = item.pbb
    saveData.value.pbde = item.pbde
    saveData.value.dehp = item.dehp
    saveData.value.dbp = item.dbp
    saveData.value.bbp = item.bbp
    saveData.value.dipb = item.dipb
    saveData.value.exemption = item.exemption
  }
  return item.id == v
})
}
 // 提交校验
 const submit = () => {
  // 校验
  if(!postData.isPromise){
    proxy.info(h_i18n('eec167ea0e6a49cc23a18df3bcfbcc50'))
    return
  }
  let item = {
    mtlNo:h_i18n('f1edca9f040d256cee01ef89fa5499f0'),
    mtlName:h_i18n('747f9e41209109f904dfa3779284b959'),
    supplyName:h_i18n('bab268d5468de413a7158920799e354d'),
    supplyCode:h_i18n('1b7ecd2bdbd8a1a112dead57724f06df'),
    rohsSystem:h_i18n('605404ab9ebb3385c54baf979384eaae'),
    guaranteeNo:h_i18n('9a311a560c9c62304ebdf6eb84b54ec3'),
    declarationDate:h_i18n('809844de5f86e5f9da3e31e24d4e5808'),
    // rohsNo:'宣告表编号',
    contactPerson:h_i18n('dad736217dba5b136a0dedd3e7fc18ec'),
    telephoneNumber:h_i18n('09a1f6985a9fb0915ecea9874daa4780'),
    address:h_i18n('7650487a8758fd50c87d6c9cff0aa5ac'),
    auditFactory:h_i18n('5d73c09499a08557279f7554a0837404'),
    // relatedMtlNo:'材料组成相同的关联专用号',
    // supplyFor:'关联供货工厂',      
  }
  for (const key in item) {
    if (!postData[key]) {
      // console.log(postData[key])
      proxy.info(`${item[key]}${h_i18n('281bada7259f6bcb836f62aa0b3e8f48')}`)
      return   
    }
  }
  if(props.kindType == 'sqmModify' && !postData.isSupply && data.overruleType != 1){
    proxy.info(`${h_i18n('b6ffb62911529fa50f54b583cdd0db5b')}`)
    return
  }
  if(data.dataOfTable?.length == 0){
    proxy.info(h_i18n('0c226c171da74e2e63719047f366b1ef'))
    return
  }
  let temp = {
    componentName:h_i18n('b0374c20a49995b229754f9ec02478ab'),
    componentSpecification:h_i18n('e6a0219a958439953a26c9d29aed5607'),
    componentSupplier:h_i18n('ef0fd88bbf96e6537c385c3c74a3fef1'),
    componentQuantity:h_i18n('5fde576e25df33b6bbf40d8a81b3e920'),
    componentWeight:h_i18n('0c0121ba7e34f0deca0418cb505788bc'),

    belongTo:h_i18n('16f51b972a1a8e7bbaa77aaabc256687'),
    testDepartment:h_i18n('a96bb77c5999b6c2e408f79ae77dd228'),
    testReportNumber:h_i18n('52142a7042d7342e3c26262ef01e8dbd'),
    fileName:h_i18n('4f64d54c8a077e48c1aa985a614eba40'),
    reportDate:h_i18n('356411c5ce7eddbda57ea45f13604439'),
    expriryTime:h_i18n('b4e63159194976119d9717cdd65070df'),

    homegenousName:h_i18n('496d57c68cd1955a224a97f71912e42a'),
    homegenousSpecification:h_i18n('bd35fa97e251886d77cf093c750dc7b7'),
    homegenousWeight:h_i18n('d7fe3347b25daf6b84e2e3ae17c7f10c'),

    pb:h_i18n('c961a63d316030126137dc9a6dbca147'),
    cd:h_i18n('884ab8248ae323fc869714e06c6cedee'),
    hg:h_i18n('f724c06aacf6a3d76efefda4d5fc60f2'),
    cr:h_i18n('d6eb939b78927fa70cf97028922fdcc8'),
    pbb:h_i18n('2bc873e2d2d3ddb59c181c00c22fc167'),
    pbde:h_i18n('c9714dad1a973a5e955a8763f3d55eee'),
    dehp:h_i18n('9cf01347d2cf9c4f8ef1fe4cddbae990'),
    dbp:h_i18n('8998bfa28186add2790c2389551a4c57'),
    bbp:h_i18n('9c8a108771a966af3ade2c5aa0da2ca0'),
    dipb:h_i18n('b272b69044900cfb6af5baec1bdf7c93'),

    exemption:h_i18n('5135b5a91526f3e49c5e8638f7852f58'),
  }
  for(let i = 0; i < data.dataOfTable.length; i ++){
    for (const key in temp) {
      if (!data.dataOfTable[i][key]) {
        proxy.info(`${h_i18n('73b6a05137a7c931f86577ad8091803c')}${i+1}${h_i18n('11450bf64ef4ad46c0b17b238dd33246')}${temp[key]}${h_i18n('281bada7259f6bcb836f62aa0b3e8f48')}`)
        return
      }
    }
  }
  // 可以提交
  postData.dataOfTable = data.dataOfTable
  emit('submitBtn',postData)
 }
 // 保存
 const save = () => {
  // 保存
  if(!postData.guaranteeNo){
    proxy.info(h_i18n('6f7db37c7dad2be669fe2895d3a5d701'))
    return
  }
  postData.dataOfTable = data.dataOfTable
  emit('saveBtn',postData)
 }

 // 返回
 const back = () => {
  emit("backBtn")
}

// 作废 
const invalid = () => {
  postData.dataOfTable = data.dataOfTable
  emit("invalidBtn",postData)
}

// 审核
const audit = () => {
  if(props.kindType == 'sqmAudit'){
    if(!postData.auditTwoStatus){
      proxy.info(h_i18n('9d29853d07cb6840afba345ff6ff559d'))
      return
    }
    if(postData.auditTwoStatus == '2' && !postData.auditTwoMark){
      proxy.info(h_i18n('a61b51c5efd48bf65f22aeef14beedf4'))
      return
    }
    // console.log('sqm审核')
    emit("auditBtn",postData)
  }else if(props.kindType == 'hmqmAudit'){
    if(!postData.checkStatus){
      proxy.info(h_i18n('9d29853d07cb6840afba345ff6ff559d'))
      return
    }
    if(postData.checkStatus == '2' && !postData.checkMark){
      proxy.info(h_i18n('a61b51c5efd48bf65f22aeef14beedf4'))
      return
    }
    // console.log('hmqm审核')
    emit("auditBtn",postData)
  }
}
// 导入按钮
const uploadBtn = () => {
  data.upLoadFlag = true
}
 /**
* 错误提示
*/
const errorFile = (str) => {
proxy.warning({ title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str })
}
/**
* h-file-upload 上传文件
*/
const fileChange = (file) => {
let formData = new FormData()
formData.append('vCode', props.getData.supplyCode)  
formData.append('upfile', file.file)
proxy.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
proxy.$http({
  method: "POST",
  url: "/base/newrohs/rohsImport", 
  data: formData
}).then(res => {
  if(res.data.code === '200'){
    if (res.data.suc.length > 0) {
      // 导入成功 data.dataOfTable 添加数据 关闭 data.upLoadFlag = false
      data.dataOfTable = res.data.suc
      data.upLoadFlag = false
    }
    if(res.data.fail.length > 0) {
      // proxy.info(h_i18n('c47d3042c5f485903b7c588717df330d'))
      proxy.info(res.data.msg || h_i18n('c47d3042c5f485903b7c588717df330d'))
    }
  }else{
    if(res.data.fail.length > 0) {
      // proxy.info(h_i18n('c47d3042c5f485903b7c588717df330d'))
      proxy.info(res.data.msg || h_i18n('c47d3042c5f485903b7c588717df330d'))
    }else{
      proxy.warning(res.data.msg)
    }
  }
    
}).catch(err => {
    proxy.error(h_i18n('6cd780d74f59166818ae64345545f71a'))
  data.document = ""
}).finally(() => {
  data.document = null
  proxy.closeLoading()
  proxy.postThisPageHeight();
})
}

/**
* h-file-upload 删除
*/
const deleteFun = () => {
data.upfileuuid = ''
data.upfilename = ''
}

/**
* h-file-upload 下载
*/
const download = () => {
proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
proxy.httpFile({
method: "get",
url: "/base/fileDownload/downloadFile?filePath=" + data.upfileuuid.split('https://sqm.haier.net/readFile/')[1],
headers: { 'content-type': 'application/json' },
}, data.upfilename)
}
// 下载模板
const downFile = (flag) => {
flag == '带识别码' && window.open('https://sqm.haier.net/readFile/basicInfo/XuanGaoInsExcelDemo-code.xlsx')
flag == '不带识别码' && window.open('https://sqm.haier.net/readFile/basicInfo/XuanGaoInsExcelDemo.xlsx')
}
// 导出识别码
const exportCode = () => {
// console.log('导出识别码')
// http://sqm-test.qd-huangdao-test.haier.net/rohs/exportRohsReportDetail?vCode=V12970
proxy.startLoading(h_i18n('4062b25e0de29c45349afa6510bf62ef'))
proxy.httpFile({
    method: "get",
    url: '/base/newrohs/exportRohsReportDetail?vCode=' + data.supplyCode,
    headers: {'content-type': 'application/json'},
  }, h_i18n('f25c3085c1cc5b67a9bbf50ce2b29116'))
}
// 导出子项信息
const exportBtn = () => {
  proxy.info({title:h_i18n('1190e465f92cd349663a4f039d1548fb'),message:h_i18n('8082a7a79d6c746e06fd627ffbf83b30'),confirmButtonText:h_i18n('f19f15bb801e21814a2f3451db786d21'),cancelButtonText:h_i18n('8afbcfdfea4d4c4ab90688df21d35893'),
    callback: (action) => {
      if (action == 'confirm') {
        // 不带附件
        proxy.startLoading(h_i18n('4062b25e0de29c45349afa6510bf62ef'))
        proxy.httpFile({
          method: "get",
          url: `/base/newrohs/exportRohsDetail?id=${props.getData.basalInfo.id}&flag=`,
          headers: {'content-type': 'application/json'},
        }, `${props.getData.basalInfo.mtlNo}${h_i18n('307959cebf5c278dffc2598326ae8304')}`)
      } else {
        // 带附件
        proxy.startLoading(h_i18n('4062b25e0de29c45349afa6510bf62ef'))
        proxy.httpFile({
          method: "get",
          url: `/base/newrohs/exportRohsDetail?id=${props.getData.basalInfo.id}&flag=T`,
          headers: {'content-type': 'application/json'},
        }, `${props.getData.basalInfo.mtlNo}${h_i18n('307959cebf5c278dffc2598326ae8304')}`)
      }
    }
  })
}
// 增加一条
const addOne = () => {
  data.addOrUp = 'add'
  data.homegenousNoList = []
  data.dialogShow = true
}
// 修改一条
const upOne = () => {
  if(data.rowListOfCheck?.length != 1){
    proxy.info(h_i18n('c1104bc73a3daab87d3aa8eea118dff5'))
    return
  }
  data.addOrUp = 'up'
  data.homegenousNoList = []
  for (const key in data.rowListOfCheck[0]) {
    if(key !='id'){
      saveData.value[key] = data.rowListOfCheck[0][key]
    }
  }
  homegenousNoListRemoteMethod()
  // console.log("iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii",data.rowListOfCheck[0].index)
  data.upIndex = data.rowListOfCheck[0].index
  data.dialogShow = true
}
const deleteRow = () => {
  if(data.rowListOfCheck?.length == 0){
    proxy.info(h_i18n('54d3aa90e7edce1476f1ded74b098626'))
    return
  }
  let newTable = data.dataOfTable.filter((item)=>{
    return !data.rowListOfCheck.some(temp=>{
      return temp.index == item.index
    })
  })
  data.dataOfTable = newTable.map(item=>item)

  data.rowListOfCheck = []
      proxy.postThisPageHeight();
    }

// 打印
const print = () => {
  data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66')]
  setTimeout(() => {
    window.print()
  },);
}

// 关闭新增弹窗
const closeDialogBtn = () => {
  saveData.value = {}
  data.dialogShow = false
}

// 编辑确定
const editBtn = () => {
  data.editBtnLoading = true
  // 为空校验
  let emptyKey = [
    'componentName','componentSpecification','componentSupplier','componentQuantity','componentWeight', //子部件/原料
    'testReportNumber','belongTo','testDepartment', // 第三方测试  -- 检测数据 可以为空
    'homegenousName','homegenousSpecification','homegenousWeight' ,  // 均质材料
    'pb','cd','hg','cr','pbb','pbde','dehp','dbp','bbp','dipb','exemption' // 限制使用物质名称
  ]
  for(let i = 0; i < emptyKey.length; i++){
    if(!saveData.value[emptyKey[i]]){
      tip[emptyKey[i]] = true
      setTimeout(() => {
        tip[emptyKey[i]] = false
        data.editBtnLoading = false
      }, 2000);
      return
    }
  }
  // if(!saveData.value.componentName){
  //   tip.componentName = true
  //   setTimeout(() => {
  //     tip.componentName = false
  //     data.editBtnLoading = false
  //   }, 2000);
  //   return
  // }
  data.dataOfTable.push(saveData.value)
  data.editBtnLoading = false
  closeDialogBtn()
  proxy.postThisPageHeight();
}

// 更新确定 
const upDateBtn = () => {
  data.editBtnLoading = true
  // 为空校验
  let emptyKey = [
    'componentName','componentSpecification','componentSupplier','componentQuantity','componentWeight', //子部件/原料
    'testReportNumber','belongTo','testDepartment', // 第三方测试  -- 检测数据 可以为空
    'homegenousName','homegenousSpecification','homegenousWeight' ,  // 均质材料
    'pb','cd','hg','cr','pbb','pbde','dehp','dbp','bbp','dipb','exemption' // 限制使用物质名称
  ]
  for(let i = 0; i < emptyKey.length; i++){
    if(!saveData.value[emptyKey[i]]){
      tip[emptyKey[i]] = true
      setTimeout(() => {
        tip[emptyKey[i]] = false
        data.editBtnLoading = false
      }, 2000);
      return
    }
  }
  if(data.upIndex >= 0){
    // console.log(data.dataOfTable)
    data.dataOfTable.splice(data.upIndex,1,saveData.value)
    data.editBtnLoading = false
    tableRef.value.clearSelection()
    closeDialogBtn()
    proxy.postThisPageHeight();
    data.upIndex = -1
  }
}
// 专用号变更后更改基本数据
const changeMtl = () => {
  proxy.$http({
    url:`/base/newrohs/validateIfAdd?supplyCode=${postData.supplyCode}&mtlNo=${postData.mtlNo}`,
    method:'get',
  }).then(res=>{
  if(res.data.data.queryFlag == '1'){
    proxy.info(h_i18n('a7101665af6b7f65cb9455c1dc5a0ec4'))
    postData.mtlNo = ''
    postData.mtlName = ''
  }else if(res.data.data.queryFlag == '2'){
    proxy.info(h_i18n('b3287d15c220247d2423e691c41b9b86'))
    postData.mtlNo = ''
    postData.mtlName = ''
  }else if(res.data.data.queryFlag == 'ok'){
    data.auditFactoryList = res.data.data.supplyForId.split(',').map((item,index)=>{
      return {valueId:item,valueName:res.data.data.supplyFor.split(',')[index]}
    })
    postData.relatedMtlNo = res.data.data.relatedMtlNo
    postData.supplyFor = res.data.data.supplyFor
    postData.supplyForId = res.data.data.supplyForId
    postData.auditFactoryId = ''
    postData.auditFactory = ''
  }
}).catch(err=>{

  }).finally(()=>{

  })
}
// 申请审核工厂 选择
const auditFactoryChange = (v) => {
  data.auditFactoryList.some(item=>{
    // console.log(item,v)
    if(v == item.valueId){
      postData.auditFactory = item.valueName
    }
    return v == item.valueId
  })
}
// 同步附件 // 打开上传
const getFile = (row,index) => {
  if(!row.testDepartment){
    proxy.info(h_i18n('561044839be2dd433f8e6a13cc01d4cc'))
    return
  }
  data.fileChoose = true
  data.index = index
  // console.log(data.index)
}
// 同步 
const getFileUuidAndFileName = () => {
  // 判断 报告号是否存在
  //api/synFile?testReportNumber=zXcZXc&testDepartment=
  proxy.$http({
    url:'/base/newrohs/synFileFromRoHSReport?testReportNumber='+data.dataOfTable[data.index].testReportNumber + '&testDepartment='+data.dataOfTable[data.index].testDepartment+'&supplyCode='+postData.supplyCode+'&belongTo='+data.dataOfTable[data.index].belongTo,
    method:'get'
  }).then(res=>{
    if(res.data.data){
      // 附件
      // data.dataOfTable[data.index].fileUuid = `https://sqm.haier.net/readFile/basicInfo/rohshelp/${data.helpBook[postData.testDepartment]}`
      // data.dataOfTable[data.index].fileName = postData.testDepartment+'.pdf'
      data.dataOfTable[data.index].fileUuid = res.data.data.fileUuid
      data.dataOfTable[data.index].fileName = res.data.data.fileName
      // 同步其他参数
      data.dataOfTable[data.index].belongTo = res.data.data.belongTo
      data.dataOfTable[data.index].reportDate = new Date(res.data.data.reportDate).toUTCString()
      data.dataOfTable[data.index].expriryTime = new Date(res.data.data.expriryTime).toUTCString()
      data.dataOfTable[data.index].uuid = res.data.data.uuid
      data.dataOfTable[data.index].isSynchro = "Y"

      proxy.success(h_i18n('19670e0858929bb2ee38ebb4105e8540'))
      data.testReportNumberFlag = true
      data.fileChoose = false
    }else{
      proxy.warning(h_i18n('d58b2c130d2d142894623a4ef6e15adf'))
      data.fileChoose = false
    }
  }).catch(err=>{

  }).finally(()=>{
  })
}
// 下载
const fileDown = (uuid,name) => {
  proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
  let uid 
  if(uuid.includes('http')){
    uid = "/base/fileDownload/downloadFile?filePath="+uuid.split('https://sqm.haier.net/readFile/')[1]
  }else{
    // let url = process.env.NODE_ENV === "production" ? "http://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    // let url = process.env.NODE_ENV === "production" ? "https://sqm.haier.net/" :  "http://sqm-test.qd-huangdao-test.haier.net/"
    uid = '/base/fileDownload/downLoadFileFtp?type=4&fileUUID='+uuid
    proxy.httpFile({
      method: "get",
      url: uid,
      headers: {'content-type': 'application/json'},
    }, name || uuid)
    return
  }
  proxy.httpFile({
    method: "get",
    url: uid,
    headers: {'content-type': 'application/json'},
  }, name)
}
// 跳转符合性声明明细
const toRohsConformityDeclarationsDetail = (mtlNo,supplyCode,supplyName,conformityDeclarationsId) => {
  if(!conformityDeclarationsId){
    proxy.info(h_i18n('e1bc8a0f19c396b979403c050bd4e4dd'))
    return
  }
  proxy.$router.push({
  name: "rohsConformityDeclarationsDetail",
  query: {
    trueName:data.trueName,
    userName:data.userName,
    dataFrom:'sqm',
    kindType:'sqmDetail',
    supplyCode,
    supplyName,
    conformityDeclarationsId,
  }
})
}
// 跳转 hmqm 符合性声明
const toHmqmRoHSDetaile = (conformityDeclarationsId) => {
  if(!conformityDeclarationsId){
    proxy.info(h_i18n('e1bc8a0f19c396b979403c050bd4e4dd'))
    return
  }
  proxy.$router.push({
    name: "detailOfRohsConformityDeclarations",
    query: {
      dataFrom:'hmqm',
      kindType:'hmqmDetail',
      conformityDeclarationsId,
      name:route.query.name,
      nickName:route.query.nickName
    }
  })
}
onBeforeMount(()=>{
  props.kindType == 'sqmAdd' && (data.title = h_i18n('66ab5e9f24c8f46012a25c89919fb191')) && (data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66')])
  props.kindType == 'sqmModify' && (data.title = h_i18n('8347a927c09a4ec2fe473b0a93f667d0')) && (data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66')])
  route.query.overruleType == 1 && (data.title = h_i18n('8347a927c09a4ec2fe473b0a93f667d0')) && (data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66'),h_i18n('d55f68b34049519d2805a2bd7dc49bca')])
  props.kindType == 'sqmAudit' && (data.title = h_i18n('cf13b1a67881f454af469aa874f087e5')) && (data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66'),h_i18n('3b69c28ccfe587be48a621c1d2e380de')])
  props.kindType == 'sqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a')) && (data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66'),h_i18n('d55f68b34049519d2805a2bd7dc49bca')])
  props.kindType == 'hmqmDetail' && (data.title = h_i18n('f82e511ce6bdd31025bb4f9f8b5cb43a')) && (data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66'),h_i18n('d55f68b34049519d2805a2bd7dc49bca')])
  props.kindType == 'hmqmAudit' && (data.title = h_i18n('cf13b1a67881f454af469aa874f087e5')) && (data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66'),h_i18n('3b69c28ccfe587be48a621c1d2e380de')])
  data.supplyCode = props.getData.supplyCode
  data.supplyName = props.getData.supplyName
  data.roleCode = props.getData.roleCode
  data.dataOfTable = props.getData.dataOfTable || []
})
onMounted(()=>{
  language.value = store.state.i18n.language;
  if(props.kindType == 'sqmAdd'){
    // 新增默认数据
    postData.supplyCode = props.getData.supplyCode
    postData.supplyName = props.getData.supplyName
    postData.guaranteeNo = props.getData.guaranteeNo
    postData.telephoneNumber = props.getData.telephoneNumber
    postData.declarationDate = proxy.time(new Date())
    postData.contactPerson = props.getData.trueName
  }else if(props.kindType == 'sqmDetail' || props.kindType == 'sqmAudit'){
    // 数据回填
    data.dataOfTable = props.getData.dataOfTable
    data.auditDataTable = props.getData.auditData
  }else if(props.kindType == 'hmqmDetail' || props.kindType == 'hmqmAudit'){
    // 数据回填
    data.dataOfTable = props.getData.dataOfTable
    data.auditDataTable = props.getData.auditData
  }else if(props.kindType == 'sqmModify'){
    // 数据回填
    postData.mtlNo = props.getData.basalInfo.mtlNo
    postData.mtlName = props.getData.basalInfo.mtlName
    postData.supplyName = props.getData.basalInfo.supplyName
    postData.supplyCode = props.getData.basalInfo.supplyCode
    postData.guaranteeNo = props.getData.basalInfo.guaranteeNo
    postData.declarationDate = props.getData.basalInfo.declarationDate
    postData.rohsNo = props.getData.basalInfo.rohsNo
    postData.contactPerson = props.getData.basalInfo.contactPerson
    postData.telephoneNumber = props.getData.basalInfo.telephoneNumber
    postData.address = props.getData.basalInfo.address
    postData.relatedMtlNo = props.getData.basalInfo.relatedMtlNo
    postData.supplyFor = props.getData.basalInfo.supplyFor
    postData.supplyForId = props.getData.basalInfo.supplyForId
    data.auditFactoryList = props.getData.basalInfo.supplyForId.split(',').map((item,index)=>{
      return {valueId:item,valueName:props.getData.basalInfo.supplyFor.split(',')[index]}
    })
    if(data.auditFactoryList.some(item =>{
      return item.valueId === props.getData.basalInfo.auditFactoryId
    })){
      postData.auditFactoryId = props.getData.basalInfo.auditFactoryId
    } else {
      postData.auditFactoryId = ''
    }
    postData.auditFactory = props.getData.basalInfo.auditFactory
    postData.rohsSystem = props.getData.basalInfo.rohsSystem
    if(props.getData.basalInfo.isPromise){
      postData.isPromise = props.getData.basalInfo.isPromise
    }
  }
  if(route.query.overruleType && route.query.overruleType ==1){
    data.overruleType = route.query.overruleType
    data.auditDataTable = props.getData.auditData
    // console.log(props.getData.auditData)
  }
  testReportNumberListFirst()
  window.addEventListener("beforeprint", function (event) {
    // 打印前的逻辑处理
    data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66')]
  });
  window.addEventListener("afterprint", function (event) {
    // 打印完成后的逻辑处理
    data.formTitle = [h_i18n('adae83b8d8e2ea891da840f74a05b88f'),h_i18n('2a6ba6309f86aadbbad3718136bd5c31'),h_i18n('ff2db8c65fc3486eb9363385e140ea66'),h_i18n('d55f68b34049519d2805a2bd7dc49bca')]
  });
})
watch(()=>props.kindType === 'sqmModify' ? props.getData.basalInfo.guaranteeNo : '',(value,oldValue)=>{
  if(value){
    postData.guaranteeNo = value
  }
})
if(props.kindType === 'sqmModify'){
  watch(()=>props.getData.basalInfo.address,(value,oldValue)=>{
    if(value){
      postData.address = value
    }
  })
  watch(()=>props.getData.basalInfo.telephoneNumber,(value,oldValue)=>{
    if(value){
      postData.telephoneNumber = value
    }
  })
}
</script>

<style lang="scss">
@page {
    size: auto;
}
@media print {
.ComponentDeclarationForm_style{
  .haier-title-lable{
    position: relative;
    .haier-title-lable-right{
      display: none;
    }
  }
  .print_style{
    display: none;
  }
  .print_show_style{
    display: table;
    .el-table__header-wrapper{
      .el-table__header{
        width: 100%!important;
      }
    }
    .el-table__body-wrapper{
      .el-table__body{
        width: 100%!important;
        tbody{
          tr{
            td{
              .cell{
                white-space: normal;
                word-break: break-all;
              }
            }
          }
        }
      }
    }
  }
}
}
.ComponentDeclarationForm_style{
.mtlNo_input_style{
  div{
    input{
      padding-left: 15px;
    }
  }
}
.top_wrap_style{
padding: 0;
}
.source_style{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block !important;
  padding-left: 5px;
}
.source_style:hover{
  white-space: unset;
  word-break: break-all;
}
.form_table_style{
div{
  table{
    border: 0 !important;
    tbody{
      tr{
        td{
          border: 0 !important;
          padding: 0;
          .el-table th > .cell {
            white-space: pre-wrap;// 表头换行
          }
          .el-table{
            .table_cell_style{
              padding: 10px 0;
            }
            .el-table__body-wrapper{
              height: 100% !important;
            }
          }
        }
      }
    }
  }
}
}
.add_dialog_style{
.haier-dialog{
  // width: 90%;
  min-width: 1300px;
  top: 5%;
  .haier-dialog--body{
    padding: 10px;
    .haier-row{
      margin-top: 10px;
    }
    .row-div-style{
      display: flex;
      justify-content: flex-start;
      padding-left: 5px;
      .haier-search{
        width: auto;
      }
      .text-top{
        .haier-search--slot{
          width: 250px;
        }
      }
    }
  }
}
}
.c_table_style{
.el-table__header-wrapper{
  .el-table__header{
    thead{
      tr{
        .c_table_th_style{
          border-right: #E5E6EB solid 1px !important;
        }
      }
    }
  }
}
}
}
.circular {
  display: inline;
  height: 30px;
  width: 30px;
  animation: loading-rotate 2s linear infinite;
}
.path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: var(--el-color-primary);
  stroke-linecap: round;
}
.planHidden{
display: none;
}
.print_show_style{
display: none;
}
</style>